import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, CheckboxModule } from 'primeng';
import { ILicenseTypes } from '../../interfaces/license-type';
import { ILicenseTypesFilter } from '../../interfaces/license-type-filter';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IPageResult } from '../../interfaces/page-result';
import { LicenseTypesService } from '../../services';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'license-types',
  templateUrl: './manage-license-types.component.html',
})
export class LicenseTypesComponent implements OnInit {
  public page: IPageResult<ILicenseTypes> = {
    items: [],
    total: 0,
  };

  public event: any;
  public filter: Subject<ILicenseTypesFilter>;
  public filterVal: ILicenseTypesFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public license: ILicenseTypes;
  public newLicense: boolean = false;
  public filterString: string;
  public newLicenseTypesForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public description: UntypedFormControl;
  public isActive: UntypedFormControl;

  constructor(private licenseTypesService: LicenseTypesService) {}

  ngOnInit() {
    this.initDefaultFilter();
    this.filter = new Subject<ILicenseTypesFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);

    // set formGroup instance
    this.name = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.description = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
    );
    this.isActive = new UntypedFormControl(true, Validators.required);

    this.newLicenseTypesForm = new UntypedFormGroup({
      name: this.name,
      description: this.description,
      isActive: this.isActive,
    });
  }

  load(filter: ILicenseTypesFilter) {
    this.licenseTypesService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  showDialogToAdd() {
    this.newLicense = true;
    this.license = {
      name: '',
      description: '',
      id: 0,
      isActive: true,
    };
    this.resetFormValues(this.license);
    this.displayDialog = true;
  }

  save(formValues) {
    this.license.name = formValues.name.trim();
    this.license.description = formValues.description;
    this.license.isActive = formValues.isActive;

    if (this.license.name !== '') {
      this.licenseTypesService.create(this.license).then((res) => this.load(this.filterVal));
    }
    this.displayDialog = false;
  }

  close() {
    this.displayDialog = false;
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.newLicense = false;
    this.license = this.cloneValet(item);
    this.resetFormValues(this.license);
    this.displayDialog = true;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event);
    }
  }

  cloneValet(c: ILicenseTypes): ILicenseTypes {
    let license = { id: 0, name: '', description: '', isActive: true };
    for (let prop in c) {
      license[prop] = c[prop];
    }
    return license;
  }

  resetFormValues(formValues) {
    this.newLicenseTypesForm.setValue({
      name: formValues.name,
      description: formValues.description,
      isActive: formValues.isActive,
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    //var eventString = JSON.stringify(event);
    //if (eventString === this.filterString) return;
    //console.log(event);
    //this.filter.next(flatten(event));

    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name', // ASC
      sortOrder: 1,
      filters: {
        name: {},
        description: {},
        isActive: {},
      },
    };
  }

  clearFilter() {
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    console.log(this.filterVal);
    this.filter.next(this.filterVal);
  }
}
